export default "__VITE_ASSET__B2QiL4td__"